import { ACTION_CALL_ACD } from '../../constants.js';

export function callAction(type, parameters = {}, callOutId=0){
  return {
    type : type,
    parameters : parameters,
    callOutId: callOutId
  }
}

export function actionHangUpCall() {
  return {
    type: ACTION_CALL_ACD.HANGUP,
  };
}

export function actionNotifyAlreadyWrapUp() {
  return {
    type: ACTION_CALL_ACD.ALREADY_WRAPUP,
  };
}

export function actionMuteCall(value) {
  return {
    type: ACTION_CALL_ACD.MUTE,
    value: value
  };
}

export function actionHoldCall() {
  return {
    type: ACTION_CALL_ACD.HOLD,
  };
}

export function actionStartStopRecording(isStop) {
  return {
    type: ACTION_CALL_ACD.START_STOP_RECORDING,
    isStop: isStop
  };
}

export function actionDTMF(digit) {
  return {
    type: ACTION_CALL_ACD.DTMF,
    digit: digit
  };
}



// WEBPACK FOOTER //
// ./src/redux/actions/A_reducer_call_acd.js